<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="Channel">
        <app-crm-shared-channel *ngIf="index === 0" [moduleId]="moduleId" [addNewElement]="addNewElement"></app-crm-shared-channel>
    </p-tabPanel>
    <p-tabPanel header="Template">
        <app-crm-shared-template *ngIf="index === 1" [moduleId]="moduleId"></app-crm-shared-template>
    </p-tabPanel>
    <p-tabPanel header="Fields">
        <app-leads-fields *ngIf="index === 2" [addNewField]="addNewField"
            (reLoadConfigurations)="reLoadConfigurations($event)" [allLeadChannels]="allCaseChannels">
        </app-leads-fields>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu #configmenuLead id="config_menu_lead" [model]="configMenuCaseItems" [popup]="true" appendTo="body">
            </p-menu>
            <span class="btnBars p-mr-0" (click)="configmenuLead.toggle($event)">
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>